import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, CircularProgress, Container, Fade, Stack, Typography } from '@mui/material';
const MESSAGES = [
    'Calculating your agency costs…',
    'Comparing against industry rates…',
    'Building your full cost report…',
];
const STEP_MS = 900;
export const CalculatingLoader = ({ onDone }) => {
    const [idx, setIdx] = useState(0);
    useEffect(() => {
        if (idx >= MESSAGES.length) {
            const t = window.setTimeout(onDone, 300);
            return () => window.clearTimeout(t);
        }
        const t = window.setTimeout(() => setIdx((i) => i + 1), STEP_MS);
        return () => window.clearTimeout(t);
    }, [idx, onDone]);
    return (_jsx(Container, { maxWidth: "sm", sx: { py: { xs: 20, md: 28 } }, children: _jsxs(Stack, { spacing: 8, alignItems: "center", textAlign: "center", children: [_jsx(CircularProgress, { size: 40, thickness: 3 }), _jsx(Box, { sx: { minHeight: 32, position: 'relative', width: '100%' }, children: MESSAGES.map((msg, i) => (_jsx(Fade, { in: i === Math.min(idx, MESSAGES.length - 1), timeout: 300, children: _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { position: 'absolute', top: 0, left: 0, right: 0, textAlign: 'center' }, children: msg }) }, msg))) })] }) }));
};
